import React from 'react'
import { useSelector } from 'react-redux'
import { MdStore } from 'react-icons/md'
import routes from '../../../config/routes'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Flex from '../../commons/Flex/Flex'
import Card from '../../commons/Card/Card'
import Text from '../../commons/Text/Text'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import Thumbnail from '../../commons/Thumbnail/Thumbnail'
import styles from './profileStoreDetail.module.scss'

const GRADIENT = 99

const breadcrumbs = [
  {
    id: 1,
    title: 'Meu perfil',
    path: routes.profile.path
  },
  {
    id: 2,
    title: 'Empresa'
  }
]

const ProfileStoreDetailContainer = () => {
  const { profile, fetching } = useSelector((state) => state.profileReducer)

  return (
    <DefaultLayout>
      <Flex column justifyContent="flex-start">
        <Text
          size="lg"
          color="gray"
          variation="dark"
          extraBold
          lineHeight="30px"
        >
          Dados da empresa
        </Text>
        <Breadcrumb items={breadcrumbs} />

        {fetching && <LoadingBounce />}

        {!fetching && profile && (
          <div className={styles.row}>
            <Flex
              alignItems="flex-start"
              style={{ width: '100%', maxWidth: '546px' }}
            >
              <Card className={styles.cardMargin}>
                <Flex
                  column
                  alignItems="flex-start"
                  justifyContent="space-evenly"
                >
                  <div className={styles.mb20}>
                    <Thumbnail type={GRADIENT}>
                      <MdStore size={25} />
                    </Thumbnail>
                  </div>
                  <Text
                    size="md"
                    color="gray"
                    variation="dark"
                    bold
                    lineHeight="24px"
                  >
                    Dados da Empresa
                  </Text>
                  <Text
                    size="xs"
                    color="gray"
                    lineHeight="24px"
                    margin="11px 0px 0px 0px"
                  >
                    Veja os dados de CNPJ.
                  </Text>
                </Flex>
              </Card>
            </Flex>

            <Flex column style={{ gap: 30, width: '100%', maxWidth: '546px' }}>
              <Card className={styles.cardMargin}>
                <Flex column>
                  <Text
                    size="md"
                    color="gray"
                    variation="dark"
                    bold
                    lineHeight="24px"
                    value="Empresa"
                  />
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    font="custom"
                    fontWeight="400"
                    lineHeight="20px"
                    margin="32px 0px"
                    value={profile.company_name ?? 'N/A'}
                  />

                  <div className={styles.divider} />
                </Flex>

                <Flex column>
                  <Text
                    size="md"
                    color="gray"
                    variation="dark"
                    bold
                    lineHeight="24px"
                    value="CNPJ"
                  />
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    font="custom"
                    fontWeight="400"
                    lineHeight="20px"
                    margin="32px 0px"
                    value={
                      profile.cnpj && profile.cnpj.length === 14
                        ? `${profile.cnpj.substring(
                            0,
                            2
                          )}.${profile.cnpj.substring(
                            2,
                            5
                          )}.${profile.cnpj.substring(
                            5,
                            8
                          )}/${profile.cnpj.substring(
                            8,
                            12
                          )}-${profile.cnpj.substring(12)}`
                        : 'N/A'
                    }
                  />

                  <div className={styles.divider} />
                </Flex>

                <Flex column>
                  <Text
                    size="md"
                    color="gray"
                    variation="dark"
                    bold
                    lineHeight="24px"
                    value="Regional"
                  />
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    font="custom"
                    fontWeight="400"
                    lineHeight="20px"
                    margin="32px 0px"
                    value={profile.regionalOffice ?? 'N/A'}
                  />

                  <div className={styles.divider} />
                </Flex>

                <Flex column>
                  <Text
                    size="md"
                    color="gray"
                    variation="dark"
                    bold
                    lineHeight="24px"
                    value="Rede"
                  />
                  <Text
                    size="xs"
                    color="gray"
                    variation="dark"
                    font="custom"
                    fontWeight="400"
                    lineHeight="20px"
                    margin="32px 0px 0px 0px"
                    value={profile.networkName ?? 'N/A'}
                  />
                </Flex>
              </Card>
            </Flex>
          </div>
        )}
      </Flex>
    </DefaultLayout>
  )
}

export default ProfileStoreDetailContainer
